import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { DifferenceComparisonCard } from './DifferenceComparisonCard'
import { alternativeIds } from 'routes/Alternatives/alternatives'
import classes from './DifferenceComparison.module.scss'

export const DifferenceComparison = () => {
  return (
    <Block as={'section'} className={classes.section}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        People switch from all of these products to Integration App. Click to
        learn why.
      </Heading>
      <ul className={classes.list}>
        {alternativeIds.map((id) => (
          <DifferenceComparisonCard id={id} key={id} />
        ))}
      </ul>
    </Block>
  )
}
